import { configureStore } from "@reduxjs/toolkit";
import LayoutSlice from "./Reducers/LayoutSlice";
import BookmarkHeaderSlice from "./Reducers/BookmarkHeaderSlice";
import ThemeCustomizerSlice from "./Reducers/ThemeCustomizerSlice";
import { isDesktop, saveCollapsed, savePinned } from "../Layout/sidebarPreference";


const Store = configureStore({
  reducer: {
    layout: LayoutSlice,
    themeCustomizer: ThemeCustomizerSlice,
    bookmarkHeader:BookmarkHeaderSlice,
  },
});

// Persist the sidebar the way the user leaves it. A collapse/expand only
// counts as a preference on desktop in the standard sidebar layout — below
// 1200px the drawer closes itself, and that mustn't overwrite the choice.
let lastCollapsed = Store.getState().layout.toggleSidebar;
let lastPinned = Store.getState().layout.pinedMenu;
Store.subscribe(() => {
  const { layout, themeCustomizer } = Store.getState();
  if (layout.pinedMenu !== lastPinned) {
    lastPinned = layout.pinedMenu;
    savePinned(layout.pinedMenu);
  }
  if (layout.toggleSidebar !== lastCollapsed) {
    lastCollapsed = layout.toggleSidebar;
    if (isDesktop() && themeCustomizer.layout === "compact-wrapper") {
      saveCollapsed(layout.toggleSidebar);
    }
  }
});

export default Store;

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
